@use "variables" as *;

.card {
  padding: $spacing-m;
}

.option {
  font-size: $fontSize-xs;
  height: 2px;
}

.price {
  font-size: $fontSize-m;
  font-weight: bold;
}

.description {
  font-size: $fontSize-s;
  font-weight: normal;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  width: 100%;
  text-align: left;
  vertical-align: top;
}

.payButton {
  width: 100%;
}
